import { CircleCheckIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "utils/cn";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/AlertDialog";
import Spinner from "components/Spinner";

import type { SentInvoiceDialogProps } from "./SentInvoiceDialog.types";
import useSentInvoiceDialog from "./useSentInvoiceDialog";

export default function SentInvoiceDialog({ open, setOpen, sendInvoicePending }: SentInvoiceDialogProps) {
  const { t } = useTranslation();

  const { handleOk } = useSentInvoiceDialog({ setOpen });

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent className="w-[400px]">
        {sendInvoicePending ? (
          <div className="flex items-center justify-center min-h-[200px]">
            <Spinner />
          </div>
        ) : (
          <>
            <AlertDialogHeader>
              <div
                className={cn(
                  "w-20 h-20 m-auto mb-5 rounded-full flex items-center justify-center bg-general-mint-600 border border-general-mint-800",
                )}
              >
                <CircleCheckIcon className="w-16 h-16 stroke-general-green-800" />
              </div>
              <AlertDialogTitle className="text-center">{t("checkout.sentInvoiceDialog.title")}</AlertDialogTitle>
              <AlertDialogDescription className="text-center">
                {t("checkout.sentInvoiceDialog.description")}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogAction className="w-full md:flex-1" onClick={handleOk} disabled={sendInvoicePending}>
                {t("button.ok")}
              </AlertDialogAction>
            </AlertDialogFooter>
          </>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
}
